<template>
  <div>
    <v-col cols="12">
      <section-header :ressource="ressource"
                      :isExtended="true"
                      :dialog="true"
                      @closeDialog="closeDialog">
      </section-header>
    </v-col>
    
    <v-row class="m-0">
      <v-col class="col-12 pt-0">
        <v-row class="d-flex">
          <v-col cols="12" class="pb-0">
            <edit-field :value="question"
                        :editFieldInfo="fieldInfo"
                        @updated="setQuestion">
            </edit-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <edit-field :value="text"
                        :editFieldInfo="fieldInfoText"
                        @updated="setText">
            </edit-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-combobox :label="typeLabel"
                        :items="types"
                        :value="type"
                        @change="setType"
                        hideDetails>
            </v-combobox>
          </v-col>
          <v-col cols="12">
            <v-combobox :label="objTypeLabel"
                        :items="objTypes"
                        :value="objType"
                        @change="setObjType"
                        hideDetails>
            </v-combobox>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="d-flex flex-row-reverse mt-4">
      <loader-button class='ms-2'
                     type='button'
                     :label='applyButton'
                     @callback="save"
                     :disabled='!canSave'>
      </loader-button>
    </div>
  </div>
</template>

<script lang="ts">
import MetaAttrib, { MetaAttribTypes } from '@/generated/classes/MetaAttrib';
import { EditFieldType, FieldInfo } from '@/framework/base/components/FieldInfo';
import EditField from '@/framework/base/components/EditField.vue';
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import { FwkButtons, RessourceFwkButton } from '@/ressources/globalRessources';
import { MapRessource } from '@/framework/base/helpers/Ressources';
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {
    LoaderButton,
    SectionHeader,
    EditField
  },
  props: {
    metaAttrib: {
      type: Object as PropType<MetaAttrib>,
      required: true
    }
  },
  data() {
    return {
      canSave: false,
      applyButton: RessourceFwkButton(FwkButtons.APPLIQUER).label,
      cloneMetaAttrib: this.metaAttrib
    };
  },
  computed: {
    ressource() {
      const ressource = new MapRessource();
      ressource.label = 'Définition de l\'attribut ' + this.cloneMetaAttrib.name;
      return ressource;
    },
    question(): string {
      return this.cloneMetaAttrib.question;
    },
    fieldInfo(): FieldInfo {
      const ressource = new MapRessource();
      ressource.label = 'Question associée à l\'attribut';
      const type = EditFieldType.STRING;
      const precision = 2;
      const format = null;
      return new FieldInfo(ressource, type, precision, this.mask, format, null, null);
    },
    text(): string {
      return this.cloneMetaAttrib.text;
    },
    fieldInfoText(): FieldInfo {
      const ressource = new MapRessource();
      ressource.label = 'Texte de substitution affiché dans le document';
      const type = EditFieldType.STRING;
      const precision = 2;
      const format = null;
      return new FieldInfo(ressource, type, precision, this.mask, format, null, null);
    },
    typeLabel(): string {
      return 'Type d\'attribut';
    },
    type(): string {
      let res = 'Sélectionner';
      Object.keys(MetaAttribTypes).forEach((val, index) => {
        if (parseInt(val) == this.cloneMetaAttrib.type as number && this.cloneMetaAttrib.type != MetaAttribTypes.NONE) {
          res = Object.values(MetaAttribTypes)[index].toString();
        }
      })
      return res;
    },
    types(): string[] {
      const res: string[] = [];
      Object.values(MetaAttribTypes).forEach((value) => {
        if (value != "NONE" && typeof (value) == 'string') {
          res.push(value);
        }
      })
      return res;
    },
    objTypeLabel(): string {
      return 'Portée de l\'attribut';
    },
    objType(): string {
      return 'Sélectionner';
    },
    objTypes(): string[] {
      const res: string[] = [];
      this.cloneMetaAttrib.paths.forEach((path) => {
        res.push(path);
      })
      return res;
    }
  },
  methods: {
    mask(value: string): string {
      return '';
    },
    setQuestion(value: string) {
      this.cloneMetaAttrib.question = value;
      this.setUpdated();
    },
    setText(value: string) {
      this.cloneMetaAttrib.text = value;
      this.setUpdated();
    },
    setType(value: string) {
      Object.values(MetaAttribTypes).forEach((val, index) => {
        if (val == value) {
          const intValue = parseInt(Object.keys(MetaAttribTypes)[index]);
          this.cloneMetaAttrib.type = intValue;
        }
      })
      this.setUpdated();
    },
    setObjType(value: string) {
      this.cloneMetaAttrib.path = value;
      this.setUpdated();
    },
    setUpdated() {
      this.canSave = this.cloneMetaAttrib.question != '' &&
        this.cloneMetaAttrib.text != '' &&
        this.cloneMetaAttrib.type != MetaAttribTypes.NONE &&
        this.cloneMetaAttrib.path != '';
    },
    save() {
      this.$emit('closeDialog');
      MetaAttrib.define(this.cloneMetaAttrib);
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
})

</script>
